import React from 'react';
import { Box, Stack } from '@mui/material';
import { CssTextField } from 'components/select';
import { useRecoilState } from 'recoil';
import ProvisioningStyles from 'pages/provisioning/day2-operation-paas/style';
import { sspSubmitOrder } from 'pages/provisioning/store/day2-operation-paas';
import HelpImg from '../../../_components/helpImg';

const ErrorDocumentPath = () => {
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [showHelperText, setHelperText] = React.useState(false);
    const [showHelperMsg, setHelperMsg] = React.useState('');
    const handleValueChange = (value) => {
        if (value !== order?.errorDocumentPath) {
            setOrder({
                ...order,
                errorDocumentPath: value,
            });
        }
    };
    React.useEffect(() => {
        if (order?.errorDocumentPath && !/^[a-zA-Z0-9-_ ]{3,255}$/.test(order?.errorDocumentPath)) {
            setHelperText(true);
            setHelperMsg('Error document path should be min. 3 to max. 255 chars only.');
        } else {
            setHelperText(false);
            setHelperMsg('');
        }
    }, [order?.errorDocumentPath]);

    return (
        <Stack direction="row" sx={ProvisioningStyles.stack}>
            <CssTextField
                autoComplete="off"
                size="small"
                sx={{
                    width: (theme) => theme.spacing('100%'),
                    '& .MuiFormHelperText-root': {
                        marginTop: (theme) => theme.spacing('-2'),
                    },
                }}
                label="Error document path *"
                error={showHelperText}
                helperText={showHelperText && <span style={ProvisioningStyles.disposal.helpText}>{showHelperMsg}</span>}
                value={order?.errorDocumentPath || ''}
                onChange={(e) => handleValueChange(e?.target?.value)}
            />
            <Box sx={ProvisioningStyles?.helpImg}>
                <HelpImg title="Please provide your error document path" />
            </Box>
        </Stack>
    );
};

export default ErrorDocumentPath;
